import styled from "@emotion/styled";

export const NavLinkAnchor = styled.a({
    cursor: 'pointer',
    color: 'black',

    ':hover': {
        textDecoration: 'underline',
    },
})